import { Box, Typography } from "@mui/material";
import PublicIcon from "@mui/icons-material/Public";
import LockIcon from "@mui/icons-material/Lock";
import React from "react";

export type VisibilityType = "Public" | "Private";

interface VisibilitySelectorProps {
  visibility: VisibilityType;
}

const iconMap = {
  Public: <PublicIcon sx={{ fontSize: 22, mr: 1 }} />,
  Private: <LockIcon sx={{ fontSize: 22, mr: 1 }} />,
};

const VisibilitySelector: React.FC<VisibilitySelectorProps> = ({
  visibility,
}) => {
  return (
    <Box display="flex" alignItems="center" gap={3}>
      <Typography sx={{ font: "var(--body-md)", color: "var(--neutral-900)" }}>
        Visibility
      </Typography>
      <Box
        sx={{
          background: "var(--neutral-50)",
          borderRadius: "8px",
          boxShadow: "none",
          textTransform: "none",
          color: "var(--neutral-1000)",
          border: "1px solid var(--neutral-100)",
          padding:
            "var(--spacing-2x) var(--spacing-2x) var(--spacing-2x) var(--spacing-4x)",
          height: 44,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "var(--spacing-3x)",
          cursor: "default",
        }}
      >
        {iconMap[visibility]}
        <Typography sx={{ font: "var(--body-sm)" }}>{visibility}</Typography>
      </Box>
    </Box>
  );
};

export default VisibilitySelector;
